module.exports = __webpack_public_path__ + "media/images/pc/staffs/mv_hair_makeup-4d842c569486b9c12e9522c3e3960422.webp";